import { Box, Flex } from '@chakra-ui/react';
import { EditActivityUpdateModel } from '../schema/editActivitySchema';
import { UseFormReturn, useWatch } from 'react-hook-form';
import FaIconWithToolTip from '../../../../../components/Icons/FaIconWithToolTip.tsx';
import { HotelBookingType } from '../../../../../globalModels/common/hotelBookingType';
import { BaseFields } from '@cks-internal/react-base';

type Props = {
  formMethods: UseFormReturn<Partial<EditActivityUpdateModel>>;
};

export const PersonalCompanyToggle = (props: Props) => {
  const bookingType = useWatch({
    control: props.formMethods.control,
    name: 'HotelBookingType'
  });

  return (
    <Box>
      <Flex gap={'5px'}>
        <BaseFields.SwitchInput
          checked={bookingType == HotelBookingType.Personal}
          onChangeControlled={(e) => {
            props.formMethods.setValue('HotelBookingType', e ? HotelBookingType.Personal : HotelBookingType.Business);
            props.formMethods.setValue('TravelerIds', []);
          }}
        />
        <FaIconWithToolTip
          tooltip={bookingType == HotelBookingType.Personal ? 'Personal' : 'Business'}
          iconName={bookingType == HotelBookingType.Personal ? 'fa-umbrella-beach' : 'fa-briefcase'}
        />{' '}

      </Flex>
    </Box>
  );
};
